import React from 'react'
import ReportCallFeeT1Page from "./ReportCallFeeT1Page"

function ReportCallFeeT1Container(props) {
    const {location} = props
    const {search} = location
    const params = search ? Object.fromEntries(new URLSearchParams(search)) : ""
    const custId = params?.custId || ''
    const custName = params?.custName || ''

    return (
        <div className="ReportByDayContainer">
            <ReportCallFeeT1Page custId={custId} custName={custName}/>
        </div>
    )
}

export default ReportCallFeeT1Container
